<template>
  <div class="right-table-wrapper" ref="tableWrapperRef">
    <div
      class="view-all-rights-compare"
      :class="{ 'view-all-rights-compare--open': showAllRightsCompare }"
      @click="handleViewAllRightsCompare"
    >
      {{ showAllRightsCompare ? '收起完整权益对比' : '查看完整权益对比' }}
      <IconArrowDown class="icon-arrow-down" :class="{ active: showAllRightsCompare }" />
    </div>

    <!-- 权益对比表格 -->
    <div v-if="showAllRightsCompare">
      <RightTable
        :visible-columns="props.personalRightsTypes"
        :is-title-visible="false"
        :enable-sticky-panel="true"
        :enable-payment-button="false"
        :sticky-top="'60px'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { IRightsType } from '@rendora/common/types/enums';
import IconArrowDown from '@rendora/design/assets/arrow-down.svg?component';
import { nextTick, ref } from 'vue';
import RightTable from '../../right-compare/ui/right-table/RightTable.vue';

// Props
const props = withDefaults(
  defineProps<{
    personalRightsTypes?: IRightsType[];
  }>(),
  {
    personalRightsTypes: () => [IRightsType.PERSONAL_LITE, IRightsType.PERSONAL],
  },
);

// 是否显示完整权益对比
const showAllRightsCompare = ref(false);
const tableWrapperRef = ref<HTMLDivElement>();

function handleViewAllRightsCompare() {
  showAllRightsCompare.value = !showAllRightsCompare.value;
  nextTick(() => {
    if (showAllRightsCompare.value) {
      tableWrapperRef.value?.scrollIntoView({ behavior: 'smooth' });
    }
  });
}
</script>

<style lang="scss" scoped>
.right-table-wrapper {
  margin-top: 0;
}

.view-all-rights-compare {
  position: sticky;
  top: 0;
  background-color: var(--x-back-1);
  font-size: var(--x-text-14-size);
  line-height: var(--x-text-14-line-height);
  color: var(--x-text-5);
  cursor: pointer;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.view-all-rights-compare--open {
}

.icon-arrow-down {
  height: 12px;
  &.active {
    transform: rotate(180deg);
  }
}
</style>
